<template>

    <v-container>

        <v-layout row wrap>

            <v-flex xs12 sm12 mb-2>

                <v-btn class="secondary white--text" @click.stop="openDialog(null)">
                    New Invoice
                    <v-icon class="white--text" right>add</v-icon>
                </v-btn>

            </v-flex>

        </v-layout>

        <v-layout row wrap>

            <v-flex xs12 sm12>
                <v-layout row>
                    <v-flex xs12>
                        <v-card>
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12 md8>
                                        <v-card-title class="headline">
                                            Invoices
                                        </v-card-title>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="search"
                                                append-icon="search"
                                                label="Search"
                                                single-line
                                                hide-details
                                                clearable
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>

                            <!--                            Status Or Filter Header-->
                            <v-layout row wrap>

                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-autocomplete
                                            clearable
                                            :items="getCustomers"
                                            label="Customer"
                                            v-model="selectedCustomersID"
                                            item-value="id"
                                            item-text="name"
                                            :search-input.sync="searchCustomer"
                                            height="48"
                                    ></v-autocomplete>
                                </v-flex>


                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-badge
                                            v-model="selectedInvoiceStatusIDs.length > 0" left>
                                        <template v-slot:badge>
                                            <span v-if="selectedInvoiceStatusIDs.length > 0">{{ selectedInvoiceStatusIDs.length }}</span>
                                        </template>

                                        <v-autocomplete style="max-width: 250px"
                                                        clearable
                                                        :items="invoiceStatuses"
                                                        label="Invoice Status"
                                                        v-model="selectedInvoiceStatusIDs"
                                                        item-value="id"
                                                        item-text="name"
                                                        multiple
                                                        chips
                                                        deletable-chips
                                                        small-chips
                                                        height="48"
                                        ></v-autocomplete>
                                    </v-badge>

                                </v-flex>


                                <v-flex grow>

                                </v-flex>

                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-autocomplete
                                            label="Filter Dates"
                                            multiple
                                            :deletable-chips=chipsDeletable
                                            v-model="selectedDateFilters"
                                            item-text="displayName"
                                            :items="dateFilters"
                                            return-object
                                            clearable
                                            height="48"
                                    >

                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-menu
                                            ref="menu"
                                            v-model="selectFromMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    :value="selectFromDate | toDateOnly"
                                                    label="Select From"
                                                    prepend-icon="fas fa-calendar"
                                                    readonly
                                                    v-on="on"
                                                    height="48"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="selectFromDate" @input="selectFromMenu = false" no-title
                                                       scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary"
                                                   @click="resetDate(selectFromDate, selectFromMenu)">CLEAR
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs12 md2 pl-4 pr-2>
                                    <v-menu
                                            ref="menu"
                                            v-model="selectToMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    :value="selectToDate | toDateOnly"
                                                    label="Select To"
                                                    prepend-icon="fas fa-calendar"
                                                    readonly
                                                    v-on="on"
                                                    height="48"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="selectToDate" @input="selectToMenu = false" no-title
                                                       scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="resetDate(selectToDate, selectToMenu)">
                                                CLEAR
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>


                            </v-layout>


                            <v-data-table
                                    :headers="headers"
                                    :items="getItems"
                                    :pagination.sync="pagination"
                                    :total-items=total
                                    class="elevation-0"
                                    :loading="loading"
                                    :rows-per-page-items="rowsPageItems"
                            >

                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                        <span>
                                          {{ props.header.text }}
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                    <v-touch tag="tr"
                                             @doubletap="openDialog(props.item.id)"
                                             @dblclick="openDialog(props.item.id)">
                                        <td>{{ props.item.id }}</td>
                                        <td class="text-xs-left">{{ props.item.invoice_number }}</td>
                                        <td class="text-xs-left">{{ props.item.customer.name }}</td>
                                        <td class="text-xs-center">
                                            <v-progress-linear
                                                    slot="progress"
                                                    :value="calculateProgress(props.item.id)"
                                                    :color="color(props.item.id)"
                                                    height="7"
                                            ></v-progress-linear>
                                        </td>

                                        <td class="text-xs-center">
                                            {{ getPositionCount(props.item.invoices_positions) }} / {{
                                            props.item.invoices_positions.length }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.invoices_status.name }}</td>
                                        <td class="text-xs-left"> {{ props.item.invoice_date | toDateOnly }}</td>
                                        <td class="text-xs-left"> {{ props.item.created_at | toDateTimeLocalTime }}</td>
                                        <td class="text-xs-right">{{ calculateTotalNetSumForRow(props.item) }} {{
                                            getPropertyByPath(props.item,'currency.name', '-')}}
                                        </td>
                                    </v-touch>

                                </template>
                                <template v-if="calculateTotalNetSumTable.length > 0" v-slot:footer>
                                    <td :colspan="headers.length -2">
                                    </td>
                                    <td class="text-xs-right" :colspan="1">
                                        <strong>Total</strong>
                                    </td>
                                    <td :colspan="1" style="padding-right: 0">
                                        <table width="100%">
                                            <tr v-for="item in calculateTotalNetSumTable">
                                                <td align="right">
                                                    <strong>
                                                        {{ formatToMoney(item.totalSum) }} {{item.currency}}
                                                    </strong>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                </v-layout>

                <addInvoiceDialog :activeTab="getActiveTab"></addInvoiceDialog>

            </v-flex>
        </v-layout>

    </v-container>

</template>

<script>
import {
  Settings,
  Invoice,
  Customer
} from '../../store/namespace-helper'
import addInvoiceDialog from '../Invoices/AddInvoiceDialog.vue'
import _ from 'lodash'

import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
import {stateHelperMixin} from '../../mixins/stateHelperMixin'
import {propertyHelperMixin} from '../../mixins/propertyHelperMixin'

import {in$, $} from 'moneysafe'

export default {
  name: 'Invoices',
  components: {
    addInvoiceDialog
  },
  mixins: [dateFunctionFilters, stateHelperMixin, propertyHelperMixin],
  props: {
    /*        procurementId: {
                      type: Number,
                      default: null
                    } */
  },
  data () {
    return {
      isVisible: false,
      pagination: {'sortBy': 'id', 'descending': true},
      search: '',
      total: 0,
      onDismissed: false,
      rowsPageItems: [25, 10, 50, 100, 250],
      deleteDialog: false,
      deleteChecked: false,
      deleteFormValidation: false,
      selectedDateFilters: [],
      selectFromDate: null,
      selectToDate: null,
      selectToMenu: false,
      selectFromMenu: false,
      dateFilters: [
        {
          column: 'invoice_date',
          displayName: 'Invoice Date',
          relation: ''
        },
        {
          column: 'created_at',
          displayName: 'Created',
          relation: ''
        }
      ],
      selectedInvoiceStatusIDs: [],
      invoiceStatuses: [],
      searchCustomer: null,
      selectedCustomersID: 0,
      chipsDeletable: true

    }
  },
  beforeDestroy () {
    this.resetStateBeforeLeaveRoute()
  },
  mounted () {
    this.loadItems()
    this.loadStatuses()
    this.loadCustomers()
    // applying styles to selector filters
    let selectors = document.getElementsByClassName('v-select__selections')
    for (let i = 0; i < selectors.length; i++) {
      selectors[i].style.maxHeight = '42px'
      selectors[i].style.overflowX = 'scroll'
    }
  },
  methods: {
    openDialog (val) {
      if (val !== null) {
        let item = this.getItems.find(x => x.id === val)
        this.$store.dispatch(Invoice.actions.setSelectedInvoice, item)
        this.$echo.private('messages-chan.' + val).listen('MessageSent', (payload) => {
          console.log('message sent event: ' + JSON.stringify(payload))
          this.$echo.leave('messages-chan.' + val)
          this.loadItems()
        })
      }
      this.$store.dispatch(Invoice.actions.openCloseDialog)
    },
    loadItems () {
      const {sortBy, descending, page, rowsPerPage} = this.pagination

      const query = {
        sortBy: sortBy || 'id',
        descending: descending ? 'desc' : 'asc',
        page: page || 1,
        limit: rowsPerPage !== -1 ? rowsPerPage : 0,
        search: this.search ? this.search : '',
        customers_id: this.selectedCustomersID ? this.selectedCustomersID : 0,
        selectedFrom: this.selectFromDate ? this.selectFromDate : null,
        selectedTo: this.selectToDate ? this.selectToDate : null,
        filterDates: this.selectedDateFilters,
        selectedInvoiceStatuses: this.selectedInvoiceStatusIDs
      }
      this.$store.dispatch(Invoice.actions.loadInvoices, query)
    },
    throttledLoadItems: _.debounce(function () {
      this.loadItems()
    }, 450),
    color (val) {
      let item = this.getItems.find(x => x.id === val)
      if (this.getPositionCount(item.invoices_positions) === item.invoices_positions.length && item.invoices_positions.length !== 0) {
        return 'success'
      } else if (this.getPositionCount(item.invoices_positions) === 0) {
        return 'error'
      } else {
        return 'warning'
      }
    },
    calculateProgress (val) {
      if (val !== null) {
        let item = this.getItems.find(x => x.id === val)
        return (100 / item.invoices_positions.length) * this.getPositionCount(item.invoices_positions)
      } else {
        return 0
      }
    },
    getPositionCount (val) {
      let count = 0
      val.forEach(function (item) {
        if (item.invoices_positions_status_id >= 2) {
          count += 1
        }
      })
      return count
    },
    calculateTotalNetSumForRow (item) {
      if (item) {
        let totalNetSum = 0
        let invoicePositions = item.invoices_positions

        if (invoicePositions) {
          invoicePositions.forEach(function (item) {
            let purchaseOrderPosition = item.purchase_order_position
            if (purchaseOrderPosition) {
              if (purchaseOrderPosition.picked_net_sum[0]) {
                totalNetSum += $(purchaseOrderPosition.picked_net_sum[0].net_sum_picked)
              }
            } else if (item.unit_price !== null) {
              for (let x = 0; x < item.quantity; x++) {
                totalNetSum += $(item.unit_price)
              }
            }
          })
        }

        return new Intl.NumberFormat('de-DE', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2

        }).format(in$(totalNetSum))
      }
    },
    resetDate (model, menu) {
      if (this.selectFromDate === model) {
        this.selectFromDate = null
        this.selectFromMenu = false
      } else if (this.selectToDate === model) {
        this.selectToDate = null
        this.selectToMenu = false
      }
    },
    loadCustomers () {
      const query = {
        search: this.searchCustomer ? this.searchCustomer : ''
      }
      this.$store.dispatch(Customer.actions.loadCustomers, query)
    },
    loadStatuses () {
      this.$store.dispatch(Invoice.actions.loadStatuses).then(response => {
        this.invoiceStatuses = response.data.data
      })
    },
    formatToMoney (totalSum) {
      return new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2

      }).format(in$(totalSum))
    }

  },
  computed: {
    getItems () {
      this.total = this.$store.getters[Invoice.getters.invoices].total
      return this.$store.getters[Invoice.getters.invoices].data
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    getActiveTab () {
      return 0
    },
    dialogState () {
      return this.$store.getters[Invoice.getters.getOpenDialogState]
    },
    getNetworkError () {
      return this.$store.getters[Settings.getters.getNetworkError]
    },
    headers () {
      return [
        {text: 'Invoice-ID', value: 'id'},
        {text: 'Invoice number', value: 'invoice_number'},
        {text: 'Customer name', value: 'customers:customers_id|customers.name'},
        /*      {text: 'Account', value: 'accounts_id'}, */
        {text: 'Progress', value: 'progress', sortable: false, align: 'left'},
        {text: 'Confirmed Positions', value: 'confirmed_position', sortable: false, align: 'center'},
        {text: 'Status', value: 'suppliers_orders_status_id', sortable: false},
        {text: 'Invoice Date', value: 'invoice_date'},
        {text: 'Created', value: 'created_at'},
        {text: 'Total Net Sum', value: 'sum_net_total', sortable: false, align: 'right'}
      ]
    },
    getCustomers () {
      return this.$store.getters[Customer.getters.customers]
    },
    calculateTotalNetSumTable () {
      let currencyTotal = {}
      let result = []

      if (this.getItems) {
        this.getItems.forEach(function (invoice) {
          let totalSumRow = 0
          if (invoice.invoices_positions) {
            invoice.invoices_positions.forEach(function (item) {
              let purchaseOrderPosition = item.purchase_order_position
              if (purchaseOrderPosition) {
                if (purchaseOrderPosition.picked_net_sum[0]) {
                  totalSumRow += $(purchaseOrderPosition.picked_net_sum[0].net_sum_picked)
                }
                // todo general function mother fucker bitch
              } else if (item.unit_price !== null) {
                for (let x = 0; x < item.quantity; x++) {
                  totalSumRow += $(item.unit_price)
                }
              }
            })
            if (currencyTotal[invoice.currencies_id]) {
              currencyTotal[invoice.currencies_id].totalSum += totalSumRow
            } else {
              currencyTotal[invoice.currencies_id] = {}
              if (invoice.currency.name) {
                currencyTotal[invoice.currencies_id].currency = invoice.currency.name
              } else {
                currencyTotal[invoice.currencies_id].currency = '-'
              }
              currencyTotal[invoice.currencies_id].totalSum = 0
              currencyTotal[invoice.currencies_id].totalSum += totalSumRow
            }
          }
        })
      }

      for (var currencyProp in currencyTotal) {
        result.push(currencyTotal[currencyProp])
      }

      return result
    }
  },
  watch: {
    pagination: {
      handler () {
        this.loadItems()
      },
      deep: true
    },
    search: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    },
    dialogState: {
      handler (val) {
        if (!val) {
          this.throttledLoadItems()
        }
      },
      deep: true
    },
    selectedCustomersID: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    },
    selectFromDate: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    },
    selectToDate: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    },
    selectedDateFilters: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    },
    selectedInvoiceStatusIDs: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    },
    searchCustomer: {
      handler (val) {
        this.loadCustomers()
      },
      deep: true
    }
  }

}
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Invoices/Invoices.vue